module.exports = __webpack_public_path__ + "static/media/loyalty_alreadyAmember.584af0dc.png";